(function(){
  var subscribe = MW.events.subscribe;
  var publish = MW.events.publish;

  // options == {callback: function(){}, subscription: "whatever"}
  function enqueue(options) {
    var queue = [],
        queueLoaded = {};

    queueLoaded[options.subscription] = true;

    subscribe(options.subscription, function() {
      queue.forEach(function(args) {
        setTimeout(function(){
          options.callback.apply(null, args);
        }, 0);
      });
      queue = [];
    });
    return function() {
      var args = arguments;

      if (queueLoaded[options.subscription]) {
        setTimeout(function(){
          options.callback.apply(null, args);
        }, 0);
      } else {
        queue.push(args);
      }
    };
  }

  var comscore = enqueue({
    subscription: "tracking_loaded_comscore",
    callback: function (payload) {
      if (window.COMSCORE) {
        COMSCORE.beacon(payload);
      }
    },
  });

  var omniture = enqueue({
    subscription: "tracking_loaded_omniture",
    callback: function (payload) {
      payload = payload || {};
      if (window.s_265) {
        var omniKeys = Object.keys(payload),
            omniTemp = {};
        omniKeys.forEach(function(key) {
          omniTemp[key] = s_265[key];
          s_265[key] = payload[key];
        });

        s_265.t();

        omniKeys.forEach(function(key) {
          s_265[key] = omniTemp[key];
        });
      }
    },
  });

  var dataLayerSet = enqueue({
    subscription: "tracking_loaded_datalayer",
    callback: function(payload) {
      if (window.bN) {
        bN.set(payload);
        var tests = MW.modules.AB.testMap();
        if("undefined" != typeof getOptimizelyTestMap) {
          tests = tests.concat(getOptimizelyTestMap()).join(',');
        }
        bN.set([["abTest", tests]]); // AB testing
      }
    }
  });

  // try{ MW.modules.AB.sample("gravityPresent") } catch(e) {}

  var dataLayerView = enqueue({
    subscription: "tracking_loaded_datalayer",
    callback: function (payload) {
      // Also needs a way to record bN_cfg.p
      if (window.bN) {
        bN.view(payload);
      }
    },
  });

  var dataLayerPing = enqueue({
    subscription: "tracking_loaded_datalayer",
    callback: function (name, payload) {
      if (window.bN) {
        bN.ping(name, (payload || {}));
      }
    }
  });

  // adds click beacons to all link within an entry text (not recirc/social/etc)
  var addBeacons = function(container) {
    var $container = container || MW.elements.$main;
    $text = $container.find('.js-entry-body');
    $tags = $text.children().not('.advertisement, .tag-cloud, .comment-button, .read-more, .sponsored-content, .slideshow-thumb, .extra-content, .slideshow-overlay, .slideshow, .books').find('a');
    for(var i = 0; i < $tags.length; i++) {
      Mobileweb.toggleBeacon($tags[i], {"mnid": "entry_text", "lnid": "citation", "mpid": i});
    }
  };

  // add PV to every 5th slide, must pass container
  // an modal slideshow can only have 1 slideshow, there can be multiple inline listicles though
  var addSlidePVs = function($container, modalSlideshow) {
    if (modalSlideshow) {
      addSlidePVsSpecific($container, modalSlideshow);
    } else {
      var $listicles = $container.find('.listicle');
      $listicles.each(function(ind, listicle) {
        addSlidePVsSpecific($(listicle), modalSlideshow);
      });
    }
  };

  // Helper function to add PV to every 5th slide of a singular slideshow
  var addSlidePVsSpecific = function($container, modalSlideshow) {
    var selector = '.listicle__slide';
    // for inline listicles we want to PV on slides 5, 10, 15, etc.
    // for modal slidehows we want to PV on slides 1, 6, 11, 16, etc.
    var listicleOffset = modalSlideshow ? 0 : 1;
    $container.find(selector).addBack(selector).each(function(ind, el) {
      if ((ind+listicleOffset) % 5 === 0) {
        var $el = $(el);
        var $parent = $el.closest('.listicle');
        $el.one('inview', function() {
          var options = {
            type: modalSlideshow ? "slideshow" : "slides_list",
            sub_type: "gallery",
            slideshow_id: $parent.data('id'),
            id: $el.data('id'),
            pos: parseInt($el.data('index'), 10) + 1,
            length: $parent.data('length'),
            credit: $el.data('credit'),
            slide_type: $el.data('type'),
            slide_filename: $el.attr('data-sharingimage'),
          };
          publish("tracking_slide_pv", options);
        });
      }
    });
  };

  subscribe("tracking_slide_pv", function(options) {
    publish("tracking_fire_pv", {
      dl: [
        ["dL_dpt", options.type, 1],
        ["dL_sDpt", options.sub_type, 1],
        ["slide_id", options.id, 1],
        ["slideshow_id", options.slideshow_id ,1],
        ["slide_position", options.pos, 1],
        ["slide_type", options.slide_type, 1],
        ["slide_filename", options.slide_filename, 1],
      ],
      omniture: {
        _1_referrer: 1,
        prop1: options.type,
        prop2: options.sub_type,
        prop53: options.type,
        prop52: "photo_"+Math.floor(options.pos/options.length*100),
        prop59: "length_"+options.length,
        prop69: options.slideshow_id,
        prop70: options.credit,
      },
      comscore: window.comscore_data
    });
  });

  // Holding back on spelling it "Tracquix"
  MW.modules.Tracky = {
    bN: {
      view: dataLayerView,
      ping: dataLayerPing,
      set: dataLayerSet,
    },
    omniture: omniture,
    comscore: comscore,
    addBeacons: addBeacons,
    addSlidePVs: addSlidePVs,
  };

  subscribe("entered_entry", function($entry) {
    var trackingData = $entry.attr("data-tracking-data");
    var tracking = $entry.attr("data-tracking");
    if (trackingData) {
      MW.elements.$trackingData.html(trackingData);
    }
    if (tracking) {
      MW.elements.$tracking.html(tracking);
      $entry.attr("data-tracking", null);
    }
    if ($entry.is('.collapsed')) {
      dataLayerPing("read_more_activated");
    }
  });

  subscribe("read_more", function() {
    omniture({prop2: "read_more", prop53: "read_more", referrer: Mobileweb.params.original_url});
    dataLayerSet([["dL_sDpt", "read_more", 1]]);
    dataLayerView();
  });

  subscribe("tracking_ping", function(payload) {
    dataLayerPing(payload.name, payload.data);
  });

  subscribe("first_scroll", function() {
    dataLayerPing("engagedPV");
  });

  subscribe("end_of_entry", function() {
    dataLayerPing("ct_end");
  });

  subscribe("window_pane_swiped", function(payload) {
    dataLayerPing("window_pane_swiped", payload.data);
  });

  var listener = subscribe("recirc_loaded", function() {
    listener.remove();
    var infinite_scrolls = 0;
    subscribe("scroll_to_bottom", function() {
      dataLayerPing("inf_scroll_mb", [["scrolls", ++infinite_scrolls]]);
    });
  });

  // More macro-y stuff
  subscribe("tracking_fire_pv", function(payload) {
    comscore(payload.comscore);
    dataLayerSet(payload.dl);
    dataLayerView();
    if (payload.pingName) { dataLayerPing(payload.pingName, payload.dl); }
    omniture(payload.omniture);
  });

  subscribe("infinite_scroll", function () {
      omniture({prop2: "infinite-scroll", prop53: "infinite_scroll"});
  });

}());